export * from './changepassword/changepassword.component';
export * from './dashboard/dashboard.component';
export * from './patient/patient.component';